const Accion = {
  alta: (funcion) => {
    const prefijo = String(process.env.REACT_APP_PREFIJO_STORAGE)
    const acciones = JSON.parse(localStorage.getItem(prefijo + 'acciones'))
    let mostrar = false
    for (let index = 0; index < acciones.length; index++) {
      if (acciones[index].funcion === funcion && acciones[index].accion === 'alta') {
        mostrar = true
        break
      }
    }
    return mostrar
  },
  edicion: (funcion) => {
    const prefijo = String(process.env.REACT_APP_PREFIJO_STORAGE)
    const acciones = JSON.parse(localStorage.getItem(prefijo + 'acciones'))
    let mostrar = false
    for (let index = 0; index < acciones.length; index++) {
      if (acciones[index].funcion === funcion && acciones[index].accion === 'edicion') {
        mostrar = true
        break
      }
    }
    return mostrar
  },
  baja: (funcion) => {
    const prefijo = String(process.env.REACT_APP_PREFIJO_STORAGE)
    const acciones = JSON.parse(localStorage.getItem(prefijo + 'acciones'))
    let mostrar = false
    for (let index = 0; index < acciones.length; index++) {
      if (acciones[index].funcion === funcion && acciones[index].accion === 'baja') {
        mostrar = true
        break
      }
    }
    return mostrar
  },
  publicar: (funcion) => {
    const prefijo = String(process.env.REACT_APP_PREFIJO_STORAGE)
    const acciones = JSON.parse(localStorage.getItem(prefijo + 'acciones'))
    let mostrar = false
    for (let index = 0; index < acciones.length; index++) {
      if (acciones[index].funcion === funcion && acciones[index].accion === 'publicar') {
        mostrar = true
        break
      }
    }
    return mostrar
  },
}

export default Accion
